import { policyHero } from '../../../../images';

export const heroData = {
  image1: policyHero,
};

export default heroData;
